import { PlacesBase } from './api-common.js';
import { BASE_API_URL } from '../envs.js';
export class Place extends PlacesBase {
    constructor(data) {
        super(data);
        if (typeof data.get === 'function')
            this.highlights = data.get('highlights');
        else
            Object.assign(this, data);
    }
}
export async function fetchPlaces(ids, lang) {
    const response = await fetch(`${BASE_API_URL}/api/4/feature/place/${ids.join(',')}?lang=${lang}`);
    return (await response.json()).map((place) => new Place(place));
}
export async function fetchPlacesByRefid(refid, lang) {
    const response = await fetch(`${BASE_API_URL}/api/4/feature/place/refid/${refid}?lang=${lang}`);
    return (await response.json()).map((place) => new Place(place));
}
//# sourceMappingURL=api-places.js.map